import { render, staticRenderFns } from "./IdCardInfo.vue?vue&type=template&id=1d9be57c&"
import script from "./IdCardInfo.vue?vue&type=script&lang=js&"
export * from "./IdCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports